import { SignatoryStatus } from '@bca-company-data/models/signatory-status-response';
import { ICompany } from '@bca-shared/models/company';
import { ICompanySignatory } from '@bca-shared/models/company-signatory';
import { IAction } from '@bca-store/models/action';

export enum CompanyDataActionTypes {
  SelectCompany = '[CompanyData] SelectCompany',
  ValidateSignatory = '[CompanyData] ValidateSignatory',
  SetSignatoryStatus = '[CompanyData] SetSignatoryStatus',
  ResetSignatoryStatus = '[CompanyData] ResetSignatoryStatus',
  FetchCompany = '[CompanyData] FetchCompany',
  CompanyLoading = '[CompanyData] CompanyLoading',
  CompanyFetching = '[CompanyData] CompanyFetching',
  SelectUserFromHistoryChecked = '[CompanyData] SelectUserFromHistoryChecked',
  DifferentContactPersonChecked = '[CompanyData] DifferentContactPersonChecked'
}

export class SelectCompany implements IAction {
  readonly type = CompanyDataActionTypes.SelectCompany;
  constructor(public readonly payload: ICompany) {}
}

export class ValidateSignatory implements IAction {
  readonly type = CompanyDataActionTypes.ValidateSignatory;
  constructor(public readonly payload: ICompanySignatory) {}
}

export class SetSignatoryStatus implements IAction {
  readonly type = CompanyDataActionTypes.SetSignatoryStatus;
  constructor(public readonly payload: {status: SignatoryStatus}) {}
}

export class ResetSignatoryStatus implements IAction {
  readonly type = CompanyDataActionTypes.ResetSignatoryStatus;
}

export class FetchCompany implements IAction {
  readonly type = CompanyDataActionTypes.FetchCompany;
  constructor(public readonly payload: ICompany) {}
}

export class CompanyLoading implements IAction {
  readonly type = CompanyDataActionTypes.CompanyLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class CompanyFetching implements IAction {
  readonly type = CompanyDataActionTypes.CompanyFetching;
  constructor(public readonly payload: { fetching: boolean }) {}
}

export class SelectUserFromHistoryChecked implements IAction {
  readonly type = CompanyDataActionTypes.SelectUserFromHistoryChecked;
  constructor(public readonly payload: { checked: boolean }) {}
}

export class DifferentContactPersonChecked implements IAction {
  readonly type = CompanyDataActionTypes.DifferentContactPersonChecked;
  constructor(public readonly payload: { checked: boolean }) {}
}

export type Action =
  | FetchCompany
  | ValidateSignatory
  | SetSignatoryStatus
  | ResetSignatoryStatus
  | SelectCompany
  | CompanyLoading
  | CompanyFetching
  | SelectUserFromHistoryChecked
  | DifferentContactPersonChecked;
